import apiClient from './axios_config';

import * as url from './url_helper';

export const getCategory = () => apiClient.get(url.GET_CATEGORY);

export const searchProduct = (params?: any) =>
  apiClient.get(url.GET_PRODUCTS, params);

export const getProductDetail = (id: string, provider: string) =>
  apiClient.get(`${url.GET_PRODUCT_DETAIL}/${id}?provider=${provider}`);

export const callExChangeRate = () => apiClient.get(url.EXCHANGE_RATE);

export const callGetMe = () => apiClient.get(url.GET_USER);
export const callGetThemes = () => apiClient.get(url.GET_THEME);
export const callGetShipping = () => apiClient.get(url.GET_SHIPPING);
export const callGetCategories = () => apiClient.get(url.GET_CATEGORY);
export const getOrders = (params?: any) =>
  apiClient.get(url.GET_ORDERS, params);

export const getOrderDetail = (id: string) =>
  apiClient.get(`${url.GET_ORDERS}/${id}`);
